import toast from 'react-hot-toast';

import { Toast } from 'shared/components/Toast';
import { DEFAULT_NOTIFICATION_DURATION } from 'shared/constants/notifications';

import type { DefaultToastOptions } from 'react-hot-toast';
import type { ToastProps } from 'shared/components/Toast';

type NotifyArgs = Partial<ToastProps> & Partial<DefaultToastOptions>;
type SpecifiedNotifyArgs = Omit<NotifyArgs, 'severity'>;

const custom = ({
  header,
  description,
  severity,
  position = 'bottom-right',
  duration = DEFAULT_NOTIFICATION_DURATION,
  ...options
}: NotifyArgs) =>
  toast.custom(
    ({ id }) => (
      <Toast
        header={header}
        description={description}
        severity={severity}
        onClose={() => {
          toast.remove(id);
        }}
      />
    ),
    { ...options, position, duration },
  );

const success = (args: SpecifiedNotifyArgs) =>
  custom({ ...args, severity: 'success' });

const error = (args: SpecifiedNotifyArgs) =>
  custom({ ...args, severity: 'error' });

const warning = (args: SpecifiedNotifyArgs) =>
  custom({ ...args, severity: 'warning' });

const info = (args: SpecifiedNotifyArgs) =>
  custom({ ...args, severity: 'info' });

export const notify = {
  custom,
  success,
  error,
  warning,
  info,
};
